// `${window.applyooConfig.LOGIN_PATH}`,



export const applyooConfig = {
    //baseServiceURL: "https://localhost:5001/applyoo/",
    API_URL: `${window.applyooConfig.API_URL}`, //"https://localhost:5001/applyoo/",
    ProjectID: -1,
    baseServiceURL: `${window.applyooConfig.API_URL}/applyoo/`, //"https://localhost:5001/applyoo/",
    //baseServiceURL: `${process.env.REACT_APP_API_URL}/applyoo/`, //"https://localhost:5001/applyoo/",
    baseFilesURL: `${window.applyooConfig.API_URL}`, //"https://localhost:5001/",
    //baseFilesURL: `${process.env.REACT_APP_API_URL}`, //"https://localhost:5001",
    IS_DEBUG_MODE: window.applyooConfig.IS_DEBUG_MODE, //`${window.applyooConfig.IS_DEBUG_MODE}`,
    IS_ALLOW_EXTERNAL_RESOURCES: window.applyooConfig.IS_ALLOW_EXTERNAL_RESOURCES, //`${window.applyooConfig.IS_DEBUG_MODE}`,
    loginPath: '/login',
    defaultLanguageCode: "he",
    // dicCurrentLanguageTitles: {},
    uiParams: {
      isAutoReplaceDataFilterWithQueryFilter: true,
    },
    jwtLogin:{
        loginEndpoint: `${window.applyooConfig.API_URL}/applyoo/AuthenticateUser`, //'https://localhost:5001/applyoo/AuthenticateUser',
        registerEndpoint: `${window.applyooConfig.API_URL}/jwt/register`, //'https://localhost:5001/jwt/register',
        refreshEndpoint: `${window.applyooConfig.API_URL}/jwt/refresh-token`, //'https://localhost:5001/jwt/refresh-token',
        logoutEndpoint: `${window.applyooConfig.API_URL}/jwt/logout`, //'https://localhost:5001/jwt/logout',
        storageTokenKeyName: 'AccessToken',
        storageRefreshTokenKeyName: 'RefreshToken'
    },
    lstVoiceToTextLanguages:[
      { key: 'en-US' , value:'Setting_Language_English', langCode: 'en'},
      { key:'he-IL' , value: 'Setting_Language_Hebrew', langCode: 'he'},
      { key:'ru-RU' , value: 'Setting_Language_Russian'},
      { key:'ar-XA' , value: 'Setting_Language_Arabic'},
      { key:'es-ES' , value: 'Setting_Language_Spanish'},
      { key:'it-IT' , value: 'Setting_Language_Italian'}
    ],
    lstLanguages:[
      { langCode: '' , value:'' ,img:'',flagCode:'' },
    ],
    constValues:{
        C_SavedFilters :  "_SavedFilters",
        C_LatestExecFilter :  "_LatestExecFilter"
    }
    
}